import { supabase } from '../supabase/client';
import { getAuthenticatedClient } from '../supabase/authenticatedClient';

export const getSettings = async () => {
  const { data, error } = await supabase.from('settings').select('*').order('key');

  if (error) {
    throw error;
  }

  return data;
};

export const getSetting = async key => {
  const { data, error } = await supabase.from('settings').select('*').eq('key', key).single();

  if (error && error.code !== 'PGRST116') {
    // Not found error
    throw error;
  }

  return data;
};

export const updateSetting = async (key, value, description = null) => {
  const client = await getAuthenticatedClient();

  // Check if setting exists
  const { data: existingSetting } = await client
    .from('settings')
    .select('*')
    .eq('key', key)
    .single();

  if (existingSetting) {
    // Update existing setting
    const { data, error } = await client
      .from('settings')
      .update({ value, description })
      .eq('key', key)
      .select()
      .single();

    if (error) {
      throw error;
    }
    return data;
  } else {
    // Create new setting
    const { data, error } = await client
      .from('settings')
      .insert([{ key, value, description }])
      .select()
      .single();

    if (error) {
      throw error;
    }
    return data;
  }
};

export const deleteSetting = async key => {
  const client = await getAuthenticatedClient();

  const { error } = await client.from('settings').delete().eq('key', key);

  if (error) {
    throw error;
  }
};
